// extracted by mini-css-extract-plugin
export default {"transaction":"Transactions_transaction__gVaAh","btn":"Transactions_btn__ogl84","message-error":"Transactions_message-error__hlM8N"};